import { mixin as clickaway } from 'vue-clickaway'

export default {
    name: 'InputDropdown',
    mixins: [ clickaway ],

    data() {
        return {
            dropdownClass: 'input-dropdown-hidden',
            filterClass: '',
            filterInputClass: '',
            error: '',
            clear: '',
            sortedData: []
        }
    },

    props: {
        label: String,
        required: Boolean,
        placeholder: String,
        value: String,
        query: String,
        data: Array,
        disabled: Boolean
    },

    created() {
        this.sortedData = this.data
    },

    methods: {
        updateValue(value) {
            this.clear = value != '' ? 'input-text-clear' : ''
            this.filter(value)
        },
        
        showItems() {
            this.dropdownClass = ''
            this.filterClass = 'input-dropdown-filter-shown'
            this.filterInputClass = 'input-dropdown-filter-input-shown'
        },

        hideItems() {
            this.dropdownClass = 'input-dropdown-hidden'
            this.filterClass = ''
            this.filterInputClass = ''
            this.doClear()
            this.$refs.inputText.blur()
        },

        selectItem(index) {
            this.$emit('change', this.sortedData[index].id)
            this.doClear()
            this.hideItems()
            this.checkForError()
        },

        checkForError() {
            this.error = this.selectedValue != '' || !this.required ? '' : 'input-dropdown-error'
        },

        doClear() {
            this.clear = ''
            this.$refs.inputText.value = ''
            // this.$refs.inputText.focus()
            this.filter('')
        },

        /**
         * search function
         * Search in all booking options
         */
        filter(searchValue) {
            this.sortedData = this.data.filter(item => { // for all items check
                    if (item.licensePlate != undefined) {
                        if (item.licensePlate.toString().toLowerCase().includes(searchValue.toLowerCase())) { // check if the LP contains the search prompt
                            return true
                        }
                    }
                    for (let i = 0; i < item.options.length; i ++) {
                        if (item.options[i].value != null || item.options[i].value != undefined) { // if there is a value
                            if (item.options[i].value.toString().toLowerCase().includes(searchValue.toLowerCase())) { // check if the item contains the search prompt
                                return true
                            }
                        }
                    }
                    return false
            })
        },
    }
}